import { List, Record } from 'immutable';

export const Order = new Record({
  id: null,
  id_asociado: null,
  Id_prestador: null,
  nro: null,
  nro_internacion: null,
  tipo: null,
  diagnostico: null,
  fecha: null,
  fecha_baja: null,
  fecha_ingreso: null,
  fecha_ult_ov: null,
  motivo_baja: null,
  estado: null,
  dt_created: null,
  dt_updated: null,
  dt_deleted: null,
  asociado: null,
  linkPDF: null,
  practicas: new List(),
  condicion_iva: null,
  cp: null,
  domicilio: null,
  legales: null,
  localidad: null,
  plan_nombre: null,
  provincia: null,
  solicitante: null,
});

export function createOrder(data) {
  return new Order({
    id: data.id,
    prestador: data.prestador,
    nro: data.nro,
    nro_internacion: data.nro_internacion,
    tipo: data.tipo,
    diagnostico: data.diagnostico,
    fecha: data.fecha,
    fecha_baja: data.fechaBaja,
    fecha_ingreso: data.fechaIngreso,
    fecha_ult_ov: data.fechaUltNov,
    motivo_baja: data.motivoBaja,
    estado: data.estado,
    dt_created: data.dt_created,
    dt_updated: data.dt_updated,
    dt_deleted: data.dt_deleted,
    asociado: data.asociado,
    linkPDF: data.linkPDF,
    practicas: new List(data.practicas) || new List(),
    condicion_iva: data.condicion_iva,
    cp: data.cp,
    domicilio: data.domicilio,
    legales: data.legales,
    localidad: data.localidad,
    plan_nombre: data.plan_nombre,
    provincia: data.provincia,
    solicitante: data.solicitante,
  });
}
